import { render, staticRenderFns } from "./PrivilegesTag.vue?vue&type=template&id=6d3f5629&scoped=true&"
import script from "./PrivilegesTag.vue?vue&type=script&lang=js&"
export * from "./PrivilegesTag.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegesTag.vue?vue&type=style&index=0&id=6d3f5629&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3f5629",
  null
  
)

export default component.exports